module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAsElEQVRIS+2VsQkCQRBF34/lGrEBUy3iEsEKTM31KrABQ/tQIxswswTBFr7MgWCitxy7iexkC7P/LZ/Z+aJwKfRtr4AWaDLxHsBV0l62D8ASuAPPTIAJMAU2AbgBF0nrTOK9jO0jMAuAgU7SLjMg9LYV8NVV29Wi3zNXLRr8k/9lUfFlV3ZdFw+cwXH4aLB9iqOkReq9PjJTazTA9jzCIRWU2Bchdn6HfllA4otGtb0Aeb6oY1EMfwgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/screen/diannao.png
// module id = uOP7
// module chunks = 3